import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { useSreenHeight } from '../../custom/useScreenHeight';

import { MapHeader } from './MapHeader';

interface MapHeaderContentProps {
	title: string;
	translation: boolean;
}

type Props = PropsWithChildren<MapHeaderContentProps>;

const StyledContainer = styled.div<{screenHeight: number}>`
	height: calc(${(props) => props.screenHeight}px - 56px);
	width: 100%;
	overflow: auto;
`;

export const MapHeaderContent = ({ title, translation, children }: Props) => {
	const screenHeight = useSreenHeight();

	return (
		<>
			<MapHeader title={title} translation={translation} />
			<StyledContainer screenHeight={screenHeight}>
				{ children }
			</StyledContainer>
		</>
	);
};
